import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useUserAuth } from '../context/UserAuthContext';
import { devError } from '../utils/devLogger';

/**
 * 전역 소켓 인증 에러 핸들러 컴포넌트
 * 토큰이 유효하지 않아서 소켓 연결 오류가 발생할 때 로그아웃 처리 및 홈으로 이동
 */
function SocketAuthErrorHandler() {
  const navigate = useNavigate();
  const { logout } = useUserAuth();

  useEffect(() => {
    const handleSocketAuthError = (event: CustomEvent) => {
      devError('🚫 [Global] 소켓 인증 에러 감지:', event.detail);
      
      // 로그아웃 처리
      logout();
      
      // 토스트 메시지 표시
      toast.error('로그인이 만료되었습니다.');
      
      // 홈으로 이동
      navigate('/', { replace: true });
    };

    // 소켓 인증 에러 이벤트 리스너 등록
    window.addEventListener('socket-auth-error', handleSocketAuthError as EventListener);
    
    return () => {
      window.removeEventListener('socket-auth-error', handleSocketAuthError as EventListener);
    };
  }, [navigate, logout]);

  // 이 컴포넌트는 UI를 렌더링하지 않음
  return null;
}

export default SocketAuthErrorHandler;